<template>
  <div>
    <p>
      This sample shows the basics of an authentication/authorization flow in a
      Microsoft Teams tab.
    </p>
    <p>
      Click on the "Login" button below to login to Azure AD, and grant the
      sample app access to your profile information. The app will fetch your
      profile using Microsoft Graph, and display information about you below.
    </p>

    <!-- Login button -->
    <v-btn class="primary" @click="login">Login to Azure AD</v-btn>
    <v-btn class="primary" @click="loginV2">Login to Azure AD (V2 endpoint)</v-btn>

    <!-- Result -->

    <div id="divError" style="display: none"></div>
    <div id="divProfile" style="display: none">
      <div>
        <b>Name:</b>
        <span id="profileDisplayName" />
      </div>
      <div>
        <b>Job title:</b>
        <span id="profileJobTitle" />
      </div>
      <div>
        <b>E-mail:</b>
        <span id="profileMail" />
      </div>
      <div>
        <b>UPN:</b>
        <span id="profileUpn" />
      </div>
      <div>
        <b>Object id:</b>
        <span id="profileObjectId" />
      </div>
    </div>
  </div>
</template>

<script>
import * as microsoftTeams from "@microsoft/teams-js";

microsoftTeams.initialize();

// Login to Azure AD and get access to Microsoft Graph
function login() {
  microsoftTeams.authentication.authenticate({
    url: window.location.origin + "/#/authStart",
    width: 600,
    height: 535,
    successCallback: function(result) {
      console.log("Login succeeded: " + result);
      alert("Login succeeded: " + result);
      getUserProfile(result.accessToken);
    },
    failureCallback: function(reason) {
      alert("Login failed: " + reason);
      console.log("Login failed: " + reason);
      handleAuthError(reason);
    }
  });
}

// Login to Azure AD and get access to Microsoft Graph
function loginV2() {
  microsoftTeams.authentication.authenticate({
    url: window.location.origin + "/#/callback",
    width: 600,
    height: 535,
    successCallback: function(result) {
      console.log("Login succeeded: " + result);

      getUserProfile(result.accessToken);
    },
    failureCallback: function(reason) {
      console.log("Login failed: " + reason);

      handleAuthError(reason);
    }
  });
}

// Get the user's profile information from Microsoft Graph
function getUserProfile(accessToken) {
  console.log(accessToken);
  /*$.ajax({
    url: "https://graph.microsoft.com/v1.0/me/",
    beforeSend: function(request) {
      request.setRequestHeader("Authorization", "Bearer " + accessToken);
    },
    success: function(profile) {
      $("#profileDisplayName").text(profile.displayName);
      $("#profileJobTitle").text(profile.jobTitle);
      $("#profileMail").text(profile.mail);
      $("#profileUpn").text(profile.userPrincipalName);
      $("#profileObjectId").text(profile.id);
      $("#divProfile").css({ display: "" });
      $("#divError").css({ display: "none" });
    },
    error: function(xhr, textStatus, errorThrown) {
      console.log("textStatus: " + textStatus + ", errorThrown:" + errorThrown);
      $("#divError")
        .text(errorThrown)
        .css({ display: "" });
      $("#divProfile").css({ display: "none" });
    }
  });*/
}

// Show error information
function handleAuthError(reason) {
  console.log(reason);
  //   $("#divError")
  //     .text(reason)
  //     .css({ display: "" });
  //   $("#divProfile").css({ display: "none" });
}

export default {
  methods: {
    login: login,
    loginV2: loginV2
  }
};
</script>

<style></style>
